module.exports = __webpack_public_path__ + "img/22250.a55df0e6.png";